import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DesigningService } from './designing.service';
import { NewStoryService } from '../new';
import { UploadWizardService } from '../wizard/wizard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'designing',
  templateUrl: './designing.component.html',
  styleUrls: ['./designing.component.scss'],
})
export class DesigningComponent implements OnInit, OnDestroy {
  @Output() showConfirmCancelDesigning = new EventEmitter();
  designingStep = 1;
  totalDesigningSteps = 6;

  constructor(
    public uploadWizardService: UploadWizardService,
    public designingService: DesigningService,
    private router: Router,
    public newStoryService: NewStoryService
  ) {}

  ngOnInit() {
    if (!this.newStoryService.images.length) {
      this.router.navigate(['/stories/new']);
    } else {
      this.designingService.updateDesignProgress();
    }
  }

  get projectId() {
    return this.newStoryService.projectId;
  }

  public nextDesigningStep() {
    window.scrollTo(0, 0);
    const nextStep = this.designingStep + 1;
    this.designingStep = nextStep;
  }

  public prevDesigningStep() {
    window.scrollTo(0, 0);
    const nextStep = this.designingStep - 1;
    this.designingStep = nextStep;
  }

  ngOnDestroy() {
    this.newStoryService.isDesignTipsShowing = false;
  }
}
